import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ErrorPage() {
  const navigate = useNavigate();

  setTimeout(() => {
    navigate('/');
  }, 3000);

  return (
    <div className='mt-5'>
      <h1 className='text-center mt-5'>404 | Page Not Found</h1>
    </div>
  );
}
